import axios from 'axios';
import { EMAIL_UNIQUE_CHECK_API, API_KEY_ACCOUNTS } from '../constants';

// ******************************
// Sync validators
// ******************************
export const required = value =>
  value || typeof value === 'number' ? undefined : 'Required';

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;

export const phone = value =>
  // eslint-disable-next-line no-useless-escape
  value && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value)
    ? 'Invalid phone number'
    : undefined;

export const coordRequired = value =>
  value || typeof value === 'number'
    ? undefined
    : 'This is an invalid address. Please use the address autocomplete.';

export const australianAddress = value =>
  // eslint-disable-next-line no-useless-escape
  value &&
  !// /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/g ||
  /([a-zA-Z]*Australia)/.test(value)
    ? 'Invalid job location, please pick from the dropdown list.'
    : undefined;

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLength9 = maxLength(9);
export const maxLength10 = maxLength(10);

export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const minLength6 = minLength(6);

export const auMobileNumber = value =>
  value && !/^04(\d){2}(\d){3}(\d){3}$/.test(value)
    ? 'Please enter a 10 digit Australian mobile number (04XXXXXXXX).'
    : undefined;
// value && !/^04(\d){2}\s(\d){3}\s(\d){3}$/.test(value)
//   ? 'Please enter a 10 digit Australian mobile number (04XX XXX XXX).'
//   : undefined;

export const auPhoneNumber = value => {
  if (!value) return undefined;

  if (value.startsWith('04')) {
    if (/^04(\d){2}(\d){3}(\d){3}$/.test(value)) {
      // if (/^04(\d){2}\s(\d){3}\s(\d){3}$/.test(value)) {
      return undefined;
    }
    return 'Please enter a 10 digit Australian mobile number (04XXXXXXXX) or phone number (02XXXXXXXX).';
    // return 'Please enter a 10 digit Australian mobile number (04XX XXX XXX) or phone number (02 XXXX XXXX).';
  }

  if (/^0(1|2|3|7|8)(\d){4}(\d){4}$/.test(value)) {
    // if (/^0(1|2|3|7|8)\s(\d){4}\s(\d){4}$/.test(value)) {
    return undefined;
  }

  return 'Please enter a 10 digit Australian mobile number (04XXXXXXXX) or phone number (02XXXXXXXX).';
  // return 'Please enter a 10 digit Australian mobile number (04XX XXX XXX) or phone number (02 XXXX XXXX).';
};

export const positiveNumber = value =>
  // eslint-disable-next-line no-useless-escape
  value && !/^[1-9]\d*$/g.test(value) ? 'Invalid number' : undefined;

export const postCode = value =>
  // eslint-disable-next-line no-useless-escape
  value &&
  !/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/g.test(
    value,
  )
    ? 'Invalid post code'
    : undefined;
// ******************************
// Async validators
// ******************************
export const validateEmailUnique = (fieldName, values, cUsername = '') => {
  const emailVal = values[fieldName];

  if (cUsername !== '' && cUsername === emailVal) {
    return Promise.resolve();
  }

  return axios({
    method: 'post',
    url: `${EMAIL_UNIQUE_CHECK_API}/my-build`,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_ACCOUNTS,
    },
    data: {
      username: emailVal,
    },
  }).then(response => {
    if (response.data === false) {
      // eslint-disable-next-line no-throw-literal
      throw {
        [fieldName]: 'This email is taken',
      };
    }
  });
};
